export const chooseAiSteps = [
    {
        target: "#choose-ai-dropdown",
        content: "Use this dropdown to select your preferred AI assistant. Choose the bot that best suits your needs for a seamless experience.",
        placement: "bottom",
        disableBeacon: true,
        disableScrolling: true,
        disableCloseOnEsc: true, 
        disableOverlayClose: true, 
    },
    {
        target: "#bot-option-deepseek",
        content: "DeepSeek excels in in-depth research and AI-driven insights.",
        placement: "right",
        event: "click", 
        offset: 10,
        disableBeacon: true,
        disableScrolling: false, 
        disableCloseOnEsc: true,
        disableOverlayClose: true,
        before: () => {
          const deepSeekOption = document.querySelector("#bot-option-deepseek");
          if (deepSeekOption) {
            deepSeekOption.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        },
    },
    {
        target: "#bot-option-claude",
        content: "Claude is optimized for coding and technical tasks.",
        placement: "right",
        disableBeacon: true,
        disableCloseOnEsc: true, 
        disableOverlayClose: true, 
        disableScrolling: true,
    },
    {
        target: "#bot-option-gemini",
        content: "Gemini is designed for fast and efficient responses.",
        placement: "right",
        disableCloseOnEsc: true, 
        disableOverlayClose: true, 
        disableBeacon: true,
        disableScrolling: true,
    },
    {
        target: "#bot-option-openai",
        content: "OpenAI is renowned for its smart reasoning and versatility.",
        placement: "right",
        disableBeacon: true,
        disableCloseOnEsc: true, 
        disableOverlayClose: true, 
        disableScrolling: true,
    },
];

export const knowledgeBaseSteps = [
    {
        target: "#knowledge-base-btn",
        content: "Click this button to access the Knowledge Base, where you’ll find a wealth of helpful resources. Whether you're looking for tutorials, FAQs, or troubleshooting guides, this section is designed to help you make the most of your AI experience.",
        placement: "right",
        disableBeacon: true,
        disableScrolling: true,
    },
    {
        target: "#knowledge-base-plus-btn",
        content: "Create a new folder or directly upload a knowledge-base files here",
        placement: "right",
        disableBeacon: true,
        disableScrolling: true,
    },
    {
        target: "#sidebar-my-files",
        content: "This section allows you to access and manage your personal files. Easily upload, store, and organize your documents, ensuring quick retrieval whenever needed. Your AI assistant can reference these files for enhanced support and automation.",
        placement: "right",
        disableBeacon: true,
        disableScrolling: true,
    },
    // {
    //     target: "#sidebar-all-user-files",
    //     content: "View and browse all user files stored within the system. This feature enables seamless collaboration by allowing access to shared files, making teamwork and information retrieval more efficient.",
    //     placement: "right",
    //     disableBeacon: true,
    //     disableScrolling: true,
    // },
    {
        target: "#sidebar-organizational-files",
        content: "Access organizational files and shared company resources in this section. These files are available to designated team members and can include important documents, policies, and other critical assets needed for collaborative work.",
        placement: "right",
        disableBeacon: true,
        disableScrolling: true,
    },
    {
        target: "#privacy-mode-tag",
        content: "This column displays the privacy setting of each file, indicating whether it's Public or Private. Click the toggle button to change its visibility. If you want your AI assistants to use a file, ensure it’s set to Public for seamless access.",
        placement: "right",
        disableBeacon: true,
        disableScrolling: true,
    },
];

export const sidebarSteps = [
    {
        target: "#explore-agents-btn",
        content: "Click this button to explore a diverse range of AI agents, each designed to assist with different tasks. Whether you're looking for a chatbot, a productivity assistant, or a specialized AI, this section helps you find the right one for your needs.",
        placement: "right",
        disableBeacon: true,
        disableScrolling: true, 
      },
      
    {
        target: "#all-agents-btn",
        content: "Use this option to browse through all available AI agents in one place. Select the one that best aligns with your personal or professional requirements.",
        placement: "right",
        disableBeacon: true,
        disableScrolling: true,
    },
    {
        target: "#personalize-assistant-btn",
        content: "Personalizing your AI assistant allows you to customize its behavior, tone, and preferences. Click this button to configure settings that align with your workflow, ensuring a tailored experience that enhances productivity and engagement.",
        placement: "top",
        disableBeacon: true,
        disableScrolling: true,
        adminOnly: true,
    },
    {
        target: "#chat-now-btn",
        content: "Ready to start a conversation? Click here to begin chatting with your selected AI assistant in real-time. Ask questions, get recommendations, or delegate tasks seamlessly within this interactive chat interface.",
        placement: "top",
        disableBeacon: true,
        disableScrolling: true,
    },
    {
        target: "#featured-agents-btn",
        content: "Discover the most popular and top-rated AI agents in this section. These AI models are highly recommended based on performance, user feedback, and effectiveness in handling various tasks. Click to explore the best AI assistants available.",
        placement: "right",
        disableBeacon: true,
        disableScrolling: true,
    },
    {
        target: "#favorite-agents-btn",
        content: "Easily access and manage your favorite AI agents here. This section allows you to quickly find the AI assistants you've marked as favorites for frequent use, making it simple to interact with the ones you rely on most.",
        placement: "right",
        disableBeacon: true,
        disableScrolling: true,
    },
    {
        target: "#org-agents-btn",
        content: "Easily access and manage your organizational AI agents here. This section allows you to quickly find the AI assistants from your organization and manage them easily",
        placement: "right",
        disableBeacon: true,
        disableScrolling: true,
    },
    {
        target: "#my-agents-btn",
        content: "Easily access and manage your personally created AI agents here. This section allows you to quickly find the AI assistants you've created and use them, making it simple to interact with the ones you rely on most.",
        placement: "right",
        disableBeacon: true,
        disableScrolling: true,
    },
    {
        target: "#team-agents-btn",
        content: "Collaborate efficiently with your team using AI-powered assistance. This section provides access to Team Agents, where you can view the agents built by your team and streamline communication within your workspace.",
        placement: "right",
        disableBeacon: true,
        disableScrolling: true,
    },

];

export const bottomNavSteps = [
    {
        target: ".bottom-navLinks",
        content: "These links provide quick access to your main navigation options at the bottom of the page.",
        placement: "top",
        disableBeacon: true,
        disableScrolling: true,
    },
    {
        target: "#my-profile-sa-navlink",
        content: "Customize your profile settings and explore additional options related to your personal account here.",
        placement: "bottom",
        disableBeacon: true,
        disableScrolling: true,
    },
    {
        target: "#settings-sa-navlink",
        content: "Modify API keys and adjust various general settings for a personalized experience.",
        placement: "right",
        disableBeacon: true,
        disableScrolling: true,
    },
    {
        target: "#usage-sa-navlink",
        content: "Monitor your monthly and weekly usage statistics to keep track of resource consumption.",
        placement: "right",
        disableBeacon: true,
        disableScrolling: true,
    },
    {
        target: "#agent-types-sa-navlink",
        content: "Add categories to filter out your agents from here",
        placement: "right",
        disableBeacon: true,
        disableScrolling: true,
    },
    {
        target: "#users-sa-navlink",
        content: "Manage organization users efficiently by adding or removing members as needed.",
        placement: "right",
        disableBeacon: true,
        disableScrolling: true,
    },
    {
        target: "#prompt-templates-sa-navlink",
        content: "Edit and customize prompt templates to suit specific needs or preferences.",
        placement: "right",
        disableBeacon: true,
        disableScrolling: true,
    },
    {
        target: "#departments-sa-navlink",
        content: "Organize and manage departments effectively within this section for better collaboration. Admins and Superadmins can create departments",
        placement: "right",
        disableBeacon: true,
        disableScrolling: true,
    },
    {
        target: "#agents-sa-navlink",
        content: "Create really cool and amazing agents for your organization here",
        placement: "right",
        disableBeacon: true,
        disableScrolling: true,
    },
    {
        target: "#task-commands-sa-navlink",
        content: "Create Task Commands for more accurate responses from provider chat interactions.",
        placement: "right",
        disableBeacon: true,
        disableScrolling: true,
    },
    {
        target: "#organizations-sa-navlink",
        content: "View all registered organizations and add new ones if necessary from here.",
        placement: "right",
        disableBeacon: true,
        disableScrolling: true,
    },
    {
        target: "#pricing-plan-sa-navlink",
        content: "Set up and manage pricing plans efficiently with this option.",
        placement: "right",
        disableBeacon: true,
        disableScrolling: true
    },
    {
        target: "#referral-program-sa-navlink",
        content: "Refer your friends on CollabAI and earn additional tokens and discounts",
        placement: "right",
        disableBeacon: true,
        disableScrolling: true
    },
    {
        target: "#subscriber-list-sa-navlink",
        content: "Quickly view all subscribers in one place for easy management.",
        placement: "right",
        disableBeacon: true,
        disableScrolling: true
    },
    {
        target: "#subscription-stats-sa-navlink",
        content: "Access detailed subscriber stats and dashboard insights here.",
        placement: "right",
        disableBeacon: true,
        disableScrolling: true
    }
]; 

export const adminBottomNavSteps = [
    {
        target: ".bottom-navLinks",
        content: "These links provide quick access to your main navigation options at the bottom of the page.",
        placement: "top",
        disableBeacon: true,
        disableScrolling: true,
    },
    {
        target: "#my-profile-ad-navlink",
        content: "Customize your profile settings and explore additional options related to your personal account here.",
        placement: "right",
        disableBeacon: true,
        disableScrolling: true,
    },
    {
        target: "#settings-ad-navlink",
        content: "Modify API keys and adjust various general settings for a personalized experience.",
        placement: "right",
        disableBeacon: true,
        disableScrolling: true,
    },
    {
        target: "#users-ad-navlink",
        content: "Manage organization users efficiently by adding or removing members as needed.",
        placement: "right",
        disableBeacon: true,
        disableScrolling: true,
    },
    {
        target: "#task-commands-ad-navlink",
        content: "Create Task Commands for more accurate responses from provider chat interactions.",
        placement: "right",
        disableBeacon: true,
        disableScrolling: true,
    },
    {
        target: "#departments-ad-navlink",
        content: "Organize and manage departments effectively within this section for better collaboration. Admins and Superadmins can create departments",
        placement: "right",
        disableBeacon: true,
        disableScrolling: true,
    },
    {
        target: "#prompt-templates-ad-navlink",
        content: "Edit and customize prompt templates to suit specific needs or preferences.",
        placement: "right",
        disableBeacon: true,
        disableScrolling: true,
    },
    {
        target: "#agents-ad-navlink",
        content: "Create really cool and amazing agents for your organization here",
        placement: "right",
        disableBeacon: true,
        disableScrolling: true,
    },
    {
        target: "#upgrade-plan-ad-navlink",
        content: "Upgrade your pricing plan and get access to most of the CollabAI features",
        placement: "right",
        disableBeacon: true,
        disableScrolling: true,
    },
    {
        target: "#billing-ad-navlink",
        content: "Check your current billing status, and features you can access",
        placement: "right",
        disableBeacon: true,
        disableScrolling: true,
    },
    {
        target: "#invite-a-friend-ad-navlink",
        content: "Invite a friend and get some additional benefits from our platform",
        placement: "right",
        disableBeacon: true,
        disableScrolling: true,
    },
    {
        target: "#subscriptions-ad-navlink",
        content: "Check your subscription plans and features you can access",
        placement: "right",
        disableBeacon: true,
        disableScrolling: true,
    },
]

export const userBottomNavSteps = [
    {
        target: ".bottom-navLinks",
        content: "These links provide quick access to your main navigation options at the bottom of the page.",
        placement: "top",
        disableBeacon: true,
        disableScrolling: true,
    },
    {
        target: "#my-profile-user-navlink",
        content: "Customize your profile settings and explore additional options related to your personal account here.",
        placement: "right",
        disableBeacon: true,
        disableScrolling: true,
    },
    {
        target: "#prompt-templates-user-navlink",
        content: "Edit and customize prompt templates to suit specific needs or preferences.",
        placement: "right",
        disableBeacon: true,
        disableScrolling: true,
    },
]